import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

axios.defaults.baseURL = process.env.VUE_APP_SERVER;
// axios.defaults.baseURL = "http://localhost/CI-CD-job-app/backend/public/api/"
// axios.defaults.baseURL = "https://job.bib-stg.com/api/"
// axios.defaults.baseURL = "https://bib-job.com/api/"

export default new Vuex.Store({
    state: {
        admin: null,
        applicant: null,
        company: null,
        resumeCountNo: null,
    },

    mutations: {
        setAdminData(state, adminData) {
            state.admin = adminData;
        },
        setApplicantData(state, applicantData) {
            state.applicant = applicantData;
        },
        setCompanyData(state, companyData) {
            state.company = companyData;
        },
        setResumeCount(state, resumeCountNo) {
            state.resumeCountNo = resumeCountNo;
        },
    },

    actions: {
        adminLogin({ commit }, credentials) {
            return axios.post('/admin/login', credentials).then(({ data }) => {
                commit('setAdminData', data);
            });
        },

        applicantLogin({ commit }, credentials) {
            return axios
                .post('/applicant/login', credentials)
                .then(({ data }) => {
                    commit('setApplicantData', data);
                });
        },

        companyLogin({ commit }, credentials) {
            return axios
                .post('/company/login', credentials)
                .then(({ data }) => {
                    commit('setCompanyData', data);
                });
        },

        adminLogout({ commit }) {
            return new Promise((resolve, reject) => {
                if (this.state.admin && this.state.admin.token) {
                    axios.defaults.headers.common['Authorization'] =
                        'Bearer ' + this.state.admin.token;
                }
                axios
                    .post('admin/logout')
                    .then((response) => {
                        commit('setAdminData', null);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        console.log('Log Out API Error', error.response);
                        commit('setAdminData', null);
                        reject(error);
                    });
            });
        },

        applicantLogout({ commit }) {
            return new Promise((resolve, reject) => {
                if (this.state.applicant && this.state.applicant.token) {
                    axios.defaults.headers.common['Authorization'] =
                        'Bearer ' + this.state.applicant.token;
                }
                axios
                    .post('applicant/logout')
                    .then((response) => {
                        commit('setApplicantData', null);
                        commit('setResumeCount', null);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        console.log('Log Out API Error', error.response);
                        commit('setApplicantData', null);
                        commit('setResumeCount', null);
                        reject(error);
                    });
            });
        },

        companyLogout({ commit }) {
            return new Promise((resolve, reject) => {
                if (this.state.company && this.state.company.token) {
                    axios.defaults.headers.common['Authorization'] =
                        'Bearer ' + this.state.company.token;
                }
                axios
                    .post('company/logout')
                    .then((response) => {
                        commit('setCompanyData', null);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        console.log('Log Out API Error', error.response);
                        commit('setCompanyData', null);
                        reject(error);
                    });
            });
        },
    },

    getters: {
        isAdminLoggedIn: (state) => !!state.admin,
        adminToken: (state) => {
            if (state.admin && state.admin.token) {
                return state.admin.token;
            }
        },
        adminId: (state) => {
            if (state.admin && state.admin.admin.id) {
                return state.admin.admin.id;
            }
        },
        adminName: (state) => {
            if (state.admin && state.admin.admin.name) {
                return state.admin.admin.name;
            }
        },
        adminEmail: (state) => {
            if (state.admin && state.admin.admin.email) {
                return state.admin.admin.email;
            }
        },

        isApplicantLoggedIn: (state) => !!state.applicant,
        applicantToken: (state) => {
            if (state.applicant && state.applicant.token) {
                return state.applicant.token;
            }
        },
        applicantId: (state) => {
            if (state.applicant && state.applicant.applicant.id) {
                return state.applicant.applicant.id;
            }
        },
        applicantName: (state) => {
            if (state.applicant && state.applicant.applicant.name) {
                return state.applicant.applicant.name;
            }
        },
        applicantEmail: (state) => {
            if (state.applicant && state.applicant.applicant.email) {
                return state.applicant.applicant.email;
            }
        },

        isCompanyLoggedIn: (state) => !!state.company,
        companyToken: (state) => {
            if (state.company && state.company.token) {
                return state.company.token;
            }
        },
        companyId: (state) => {
            if (state.company && state.company.company.id) {
                return state.company.company.id;
            }
        },
        companyName: (state) => {
            if (state.company && state.company.company.company_name) {
                return state.company.company.name;
            }
        },
        companyEmail: (state) => {
            if (state.company && state.company.company.email) {
                return state.company.company.email;
            }
        },
        resumeCountNo: (state) => {
            if (state.resumeCountNo) {
                return state.resumeCountNo;
            } else {
                return 0;
            }
        },
    },

    plugins: [createPersistedState()],
});
